<template>
  <div class="inputs__wrapper">
    <div class="input-wrapper" :class="{ 'input-error': inputErrorData.first_name?.length > 0 }">
      <label for="first_name">First name <span class="orange-star">*</span></label>
      <input
        id="first_name"
        v-model.trim="inputData.first_name"
        class="tex"
        type="text"
        name="first_name"
        placeholder="First Name"
        @input="handleInput('first_name')"
      />
      <img
        v-if="inputData.first_name?.length > 0"
        src="../../assets/images/cross_grey.svg"
        alt="cross"
        @click="clearInput('first_name')"
      />
      <span v-if="inputData.first_name?.length > 0" class="error-text">{{
        inputErrorData.first_name
      }}</span>
    </div>
    <div class="input-wrapper" :class="{ 'input-error': inputErrorData.email?.length > 0 }">
      <label for="email">Business email <span class="orange-star">*</span></label>
      <input
        id="email-address"
        v-model.trim="inputData.email"
        type="text"
        name="email"
        placeholder="Business Email"
        @input="handleInput('email')"
      />
      <img
        v-if="inputData.email?.length > 0"
        src="../../assets/images/cross_grey.svg"
        alt="cross"
        @click="clearInput('email')"
      />
      <span v-if="inputData.email?.length > 0" class="error-text">{{ inputErrorData.email }}</span>
    </div>
    <div
      class="input-wrapper"
      :class="{
        'input-error': inputErrorData.referral_source?.length > 0,
      }"
    >
      <label for="referral_source"
        >How did you hear about us? <span class="orange-star">*</span></label
      >
      <input
        id="referral_source"
        v-model.trim="inputData.referral_source"
        type="text"
        name="referral_source"
        placeholder="How did you hear about us?"
        @input="handleInput('referral_source')"
      />
      <img
        v-if="inputData.referral_source?.length > 0"
        src="../../assets/images/cross_grey.svg"
        alt="cross"
        @click="clearInput('referral_source')"
      />
      <span v-if="inputData.referral_source?.length > 0" class="error-text">{{
        inputErrorData.referral_source
      }}</span>
    </div>
  </div>
</template>
<script>
import {
  validateEmail,
  checkFieldCompleteness,
  checkFormInputsForCompleteness,
  isGmail,
} from '../../services/functions';

export default {
  props: {
    stepData: Object,
  },
  data() {
    return {
      inputData: {
        first_name: this.stepData ? this.stepData.first_name || '' : '',
        email: this.stepData ? this.stepData.email : '',
        referral_source: this.stepData ? this.stepData.referral_source : '',
      },
      inputErrorData: {
        first_name: '',
        email: '',
        referral_source: '',
      },
    };
  },

  methods: {
    clearInput(inputField) {
      this.inputData[inputField] = '';
      this.inputErrorData[inputField] = '';
      this.$emit('updateInputData', { ...this.inputData });
      this.$emit('updateIsDataComplete', this.isComplete());
      this.$emit('updateIsDataValid', this.validateInput(inputField));
    },
    handleInput(inputField) {
      this.inputErrorData[inputField] = '';
      this.$emit('updateInputData', { ...this.inputData });
      this.$emit('updateIsDataComplete', this.isComplete());
      this.$emit('updateIsDataValid', this.validateInput(inputField));
    },
    isComplete() {
      return checkFormInputsForCompleteness(this.inputData);
    },
    validateInput(inputField) {
      if (!checkFieldCompleteness(this.inputData[inputField])) {
        this.inputErrorData[inputField] = 'Max input length 1000';
        return false;
      }
      if (inputField === 'email' && this.inputData.email.length > 0) {
        const isEmailValid = validateEmail(this.inputData.email) && !isGmail(this.inputData.email);
        if (!isEmailValid) {
          this.inputErrorData.email =
            'Please use corporate email so we can better support your request.';
        }
        return isEmailValid && this.isComplete();
      } else {
        return this.isComplete();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables/variablesForRequestDemo';
@import '../../assets/css/fonts';

.inputs__wrapper {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  width: 100%;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  gap: 8px;
}

.input-wrapper label {
  @include Aspekta-font(400, 14px, 140%, #797e86);
  letter-spacing: 0em;
}

.input-wrapper input:focus-visible {
  outline: none;
  border: 1px solid #3180f6;
}

.input-error input:focus-visible {
  border: 1px solid #fe2027;
}

.input-wrapper img {
  height: 11px;
  width: 11px;
  position: absolute;
  bottom: 20px;
  right: 21px;
  cursor: pointer;
}

.input-wrapper {
  &:focus-within {
    label {
      color: #3180f6;
    }
  }
}

.input-error {
  &:focus-within {
    label {
      color: #fe2027;
    }
  }
}

.input-wrapper input {
  @include Aspekta-font(450, $dynamic-demo-input-placeholder-font-size, 150%, #0c0d0e);
  letter-spacing: 0em;
  border: 1px solid #e8e7ef;
  padding: 12px 39px 12px 24px;
  border-radius: 10px;
  text-overflow: ellipsis;
  background: #fff;

  &::placeholder {
    color: #797e86 !important;
  }
}

.orange-star {
  @include Aspekta-font(700, 14px, 140%, #ff7a08);
}

.error-text {
  @include Aspekta-font(400, 12px, 150%, #fe2027);
  position: absolute;
  top: 100%;
  margin-top: 4px;
}

@media (max-width: 1000px) {
  .input-wrapper input {
    padding: 18px 35px 18px 16px;
  }

  .input-wrapper img {
    bottom: 25px;
  }
}
</style>
